/** Standard max logo upload size (matches typical profile/business logo limits). */
export const LOGO_MAX_BYTES = 2 * 1024 * 1024; // 2 MB
export const LOGO_MAX_LABEL = "2 MB";

export function isLogoTooLarge(file) {
  return file.size > LOGO_MAX_BYTES;
}

export function logoTooLargeMessage() {
  return `Image must be under ${LOGO_MAX_LABEL}. Try a PNG or JPG, or compress slightly if needed.`;
}
